import React from "react";
import { NavItem } from "../NavItem";

import { NavMenuWrapper } from "./styles";
import { NavMenuProps } from "./types";

/**
 * Componente NavMenu
 *
 * Exibe um menu de navegação com itens interativos.
 *
 * @param {MenuItem[]} items - Lista de itens de menu para exibição.
 */
export const NavMenu: React.FC<NavMenuProps> = ({ items }) => {
  return (
    <NavMenuWrapper>
      {items.map((item, index) => (
        <NavItem key={index} label={item.label} action={item.action} />
      ))}
    </NavMenuWrapper>
  );
};
